{
  "lang": "en",
  "alias": "berkeley",
  "theme": "template-toggle-clean",
  "master": "./masters/template-toggle-clean/bbdefault/",
  "plugins": [
    "a11y-describedby",
    "a11y-user-detect",
    "asterisk",
    "auto-next-when-only-radio",
    "bb-input-wrap-and-unit",
    "broadcast-fields",
    "broadcast-fields--receiver",
    "case-filter-extra",
    "case-template",
    "change-earlier-then-next",
    "chapters",
    "close-caseslist",
    "csv-writer",
    "datatables-styled",
    "feedback-local",
    "gauge",
    "grid-tabs",
    "grids-to-graphs",
    "has-no-next",
    "headings",
    "history",
    "iconset",
    "info-inline",
    "legacy",
    "markdown-it",
    "markdown-it-converter",
    "md-labels",
    "model-filter",
    "modelinfo",
    "modelitem",
    "models-authored",
    "no-fastforward",
    "non-indenting-jumplist",
    "previews",
    "questionlabelgroup-ng",
    "reset-password",
    "show-server-side-validation",
    "skip",
    "style-grid",
    "tabs",
    "wrap-table"
  ],
  "arbitrary": {
    "headings": {
      "baseLevel": "2"
    },
    "core": {
      "skipNumButtons": true,
      "wrapAllSingleLiners": true
    },
    "previews": {
      "showChanges": true
    },
    "legacy": {
      "notice": "<h1>Sorry :(</h1>The MID requires a modern browser.<br/>Supported browsers: <ul><li>Last (3) versions of Chrome<li>Firefox, current ESR (78.15.0esr) or above,<li>Chromium-based Edge (from version 80)<li>Safari version 13.1 on OSX</ul>Limited support for Safari on iOS.<br>Internet Explorer and old Microsoft Edge (up to and including version 18) are <strong>not</strong> supported.<br>.Javascript must be turned on."
    }
  },
  "template": {
    "logo": "custom/berkeley/conf/images/BB-logo-default.png",
    "favicon": "images/favicon-bb.png",
    "companyname": "Berkeley Bridge",
    "companywebsite": "https://www.berkeleybridge.com/",
    "breakpoint": "1050",
    "less": {
      "post": [
        "sizes",
        "vars-bb-theme"
      ]
    },
    "themeColor": "#182a64",
    "readonly-prop": "disabled"
  },
  "legacy": false,
  "fonts": [
    "roboto-v27"
  ]
}
